export default "__VITE_ASSET__9ybL9j2x__"